module.exports = __webpack_public_path__ + "assets/img/a73b-gf.svg";